import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAllScenarios } from "../../redux/slices/scenarioSlice";
import ScenarioCard from "./ScenarioCard";
import { Link } from "react-router-dom";
import { LineWave } from "react-loader-spinner";
import Cookies from "js-cookie";

const Scenario = () => {
  const dispatch = useDispatch();
  const scenarioData = useSelector((state) => state.scenarioReducer);

  const role = Cookies?.get("role");

  useEffect(() => {
    dispatch(getAllScenarios());
  }, []);

  return (
    <>
    <h1 className="text-left text-white text-3xl font-bold ml-1">
      Scenarios
    </h1>
    <div className="pt-4 bg-[#150C3F]">
      <div className="text-right pr-2">
        {role === "director" ? (
          <button type="button" disabled className="bg-red-500 text-white font-bold py-2 px-4 rounded inline-block mb-5 cursor-not-allowed"> Create Scenario</button>
        ) : (
          <Link
            to="/panel/createscenario"
            className="bg-red-500 text-white font-bold py-2 px-4 rounded inline-block mb-5"
          >
            Create Scenario
          </Link>
        )}
      </div>
      <div className="flex flex-wrap">
        {scenarioData?.scenarios?.data?.map((item) => (
          <ScenarioCard {...item} key={item?._id} />
        ))}
      </div>
      {scenarioData?.isLoading && (
        <div className="loader">
          <LineWave
            color={"#fff"}
            loading={scenarioData?.isLoading}
            size={150}
          />
        </div>
      )}
    </div>
    </>
  );
};

export default Scenario;
